import * as THREE from 'three';
import { getObstacleType } from '@/utils/enumHelper.js';
const ENUM_VALUES = getObstacleType();
// 配置默认参数
const DEFAULT_CONFIG = {
  fontSize: 12,
  color: '#ed1941',
  padding: 8,
  resolutionScale: 3,  // 清晰度倍增系数
  fontFamily: 'Arial',
  fontWeight: 'bold',
  textBaseline: 'top',
  antialias: true
};
/**
 * 绘制文字，返回一个Sprite；
 * @param {*} textList  文本list，按照文本list换行显示
 * @param {*} size  文本的大小；
 * @returns
 */
export function createSpriteText(
  textList = [],
  size = 30,
  color = '#ed1941',
  height = 400,
  width = 800,
  lineColors = null,
  fontWeight = 'Bold',
) {
  //先用画布将文字画出
  let canvas = document.createElement('canvas');
  let ctx = canvas.getContext('2d');
  canvas.height = height;
  canvas.width = width;
  ctx.font = `${fontWeight} ${size}px Arial`;
  ctx.lineWidth = 2;
  let y = size;
  textList.forEach((text, index) => {
    ctx.fillStyle = lineColors?.[index] || color;
    ctx.fillText(text, 4, y + index * (size + 2));
  });

  let texture = new THREE.Texture(canvas);
  texture.needsUpdate = true;

  //使用Sprite显示文字
  let material = new THREE.SpriteMaterial({ map: texture, depthTest: false });
  let textObj = new THREE.Sprite(material);
  textObj.position.set(0, 0, 0);
  textObj.renderOrder = 100;
  return textObj;
}

/**
 * 绘制文字，返回一个Sprite；
 * @param {*} textList  文本list，按照文本list换行显示
 * @param {*} size  文本的大小；
 * @returns
 */
export function createSpriteText_map(
  textList = [],
  size = 30,
  color = '#ed1941',
  height = 40,
  width = 60,
) {
  //先用画布将文字画出
  let canvas = document.createElement('canvas');
  let ctx = canvas.getContext('2d');
  
  // 设置字体用于测量文本宽度
  ctx.font = `Bold ${size}px Arial`;
  
  // 计算所有文本中的最大宽度，并增加足够的安全边距
  let maxTextWidth = 0;
  textList.forEach((text) => {
    const metrics = ctx.measureText(String(text));
    // 使用actualBoundingBox获取更准确的宽度（如果支持）
    const textWidth = metrics.actualBoundingBoxRight !== undefined 
      ? metrics.actualBoundingBoxLeft + metrics.actualBoundingBoxRight
      : metrics.width;
    maxTextWidth = Math.max(maxTextWidth, textWidth);
  });
  
  // 动态设置canvas尺寸，确保能容纳所有文本
  const startX = 10;  // 增加文本起始X坐标
  const paddingRight = Math.max(30, size);  // 增加更大的右侧padding
  const calculatedWidth = Math.ceil(maxTextWidth + startX + paddingRight);
  canvas.width = Math.max(width, calculatedWidth);
  canvas.height = Math.max(height, size + textList.length * (size + 2) + 60);
  
  // 设置canvas尺寸后需要重新设置字体和样式
  ctx.fillStyle = color;
  ctx.font = `Bold ${size}px Arial`;
  ctx.textBaseline = 'top';  // 使用top基线更精确
  ctx.lineWidth = 2;
  
  // 可选：添加背景色用于调试（正式环境可以注释掉）
  // ctx.fillStyle = 'rgba(0, 0, 0, 0.3)';
  // ctx.fillRect(0, 0, canvas.width, canvas.height);
  
  ctx.fillStyle = color;
  let y = 50;
  textList.forEach((text, index) => {
    ctx.fillText(String(text), startX, y + index * (size + 2));
  });

  let texture = new THREE.Texture(canvas);
  texture.needsUpdate = true;

  //使用Sprite显示文字
  let material = new THREE.SpriteMaterial({ map: texture });
  let textObj = new THREE.Sprite(material);
  textObj.position.set(0, 0, 0);
  // Sprite 默认是 1:1 正方形，按贴图宽高比缩放可避免长文本被压瘦
  const aspect = canvas.width / canvas.height || 1;
  textObj.scale.set(aspect, 1, 1);
  textObj.renderOrder = 100;
  return textObj;
}

/**
 * 绘制文字，返回一个Sprite；
 * @param {*} textList  文本list，按照文本list换行显示
 * @param {*} size  文本的大小；
 * @returns
 */
// export function updateSpriteText(canvas, textList = [], size = 14) {
//     //先用画布将文字画出
//     let canvas = document.createElement("canvas");
//     let ctx = canvas.getContext("2d");
//     ctx.fillStyle = "#ffff00";
//     ctx.font = `Bold ${size}px Arial`;
//     ctx.lineWidth = 2;
//     let y = size;
//     textList.forEach((text, index) => {
//         ctx.fillText(text, 4, y + index * (size + 2));
//     });

//     let texture = new THREE.Texture(canvas);
//     texture.needsUpdate = true;

//     //使用Sprite显示文字
//     let material = new THREE.SpriteMaterial({ map: texture });
//     let textObj = new THREE.Sprite(material);
//     textObj.position.set(0, 0, 0);
//     textObj.renderOrder = 100;
//     textObj.canvas = canvas;
//     return textObj;
// }

export function createSpriteTextList(
  textList = [],
  size = 30,
  color = '#ed1941',
  height = 200,
  width = 750,
) {
  //先用画布将文字画出
  let canvas = document.createElement('canvas');
  let ctx = canvas.getContext('2d');
  canvas.height = height;
  canvas.width = width;
  ctx.fillStyle = '#ed1941';
  ctx.font = `Bold ${size}px Arial`;
  ctx.lineWidth = 2;
  let y = size;
  textList.forEach((text, index) => {
    ctx.fillText(text, 4, y + index * (size + 2));
  });

  let texture = new THREE.Texture(canvas);
  texture.needsUpdate = true;

  //使用Sprite显示文字
  let material = new THREE.SpriteMaterial({ map: texture });
  let textObj = new THREE.Sprite(material);
  textObj.position.set(0, 0, 0);
  textObj.renderOrder = 100;
  return textObj;
}

// 缓存所有枚举对应的材质
const spriteMaterialCache = {};

// 初始化所有枚举材质（只需调用一次）
function initSpriteMaterials() {
  const fontSize = 40;
  const padding = 40;

  ENUM_VALUES.forEach((item) => {
    // 1. 使用临时canvas测量文本宽度
    const tempCanvas = document.createElement('canvas');
    const tempCtx = tempCanvas.getContext('2d');
    tempCtx.font = `Bold ${fontSize}px Arial`;
    const textWidth = tempCtx.measureText(item.label).width;

    // 2. 创建正式Canvas（使用新的变量名）
    const canvas = document.createElement('canvas');
    canvas.width = textWidth + padding * 2;
    canvas.height = fontSize + padding * 2;
    const ctx = canvas.getContext('2d'); // 这里使用新的ctx变量

    // 3. 绘制文本
    ctx.fillStyle = '#00ff00';
    ctx.font = `Bold ${fontSize}px Arial`;
    ctx.textBaseline = 'top';
    ctx.fillText(item.label, padding, padding / 2);

    // 4. 创建材质
    const texture = new THREE.Texture(canvas);
    texture.needsUpdate = true;
    spriteMaterialCache[item.label] = new THREE.SpriteMaterial({
      map: texture,
      transparent: true
    });
  });
}
export function createSpriteEnum(label) {
  if (!spriteMaterialCache[label]) {
    initSpriteMaterials();
  }
  // 克隆材质（避免多个 Sprite 共享同一个材质）
  const material = spriteMaterialCache[label].clone();
  const textObj = new THREE.Sprite(material);
  textObj.position.set(0, 0, 0);
  textObj.renderOrder = 100;
  return textObj;
}


